import {l} from "../../types/typescriptdefinisjoner_lederplan";
import {Kontekst} from "../tjenester/Kontekst";
import {stateManglendeTilgangsnivåEvent} from "./Tilgangshaandtering";
import {IScope} from "angular";

export abstract class UiRouterFasade {
    static regNavn = 'UiRouterFasade';

    constructor(public $rootScope: IScope, public kontekst: Kontekst) {
    }

    abstract currentState(): UiRouterState;

    /**
     * registrer event handler som broadcaster en stateManglendeTilgangsnivåEvent event på rootScope dersom
     * {@link Kontekst#harTilgangTilState} returnerer usann.
     *
     * Transisjon til forespurt state blir avbrutt dersom bruker ikke har tilgang.
     */
    registrerStateAutoriasasjon() {
        this.registrerStateAutoriasasjonsHåndtering((fra: UiRouterState, til: UiRouterState) => {
            const tilgang = this.kontekst.harTilgangTilState(til);
            if (!tilgang) this.$rootScope.$broadcast(stateManglendeTilgangsnivåEvent, fra, til);
            return tilgang;
        })
    };

    abstract registrerStateAutoriasasjonsHåndtering(harTilgang: (fra: UiRouterState, til: UiRouterState) => boolean);
}

export abstract class UiRouterState {
    name: string;
    url: string;
    tilgangsroller: l.TilgansrollerBruker[];
}
